<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-layer-group"></i> Production Items
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable
          :columns="columnList"
          defaultColumnOrderDir="DESC"
          :defaultColumnOrderIndex="6"
          :url="dataURL"
          :filterOptions="filterOptions"
          :displayTools="true"
          :useReportingServer="true"
          :hasDateRangeFilter="true"
          :displayExportTools="true"
          exportTitle="Production Items">
          <template v-slot:title>
            <h3>Production Item List</h3>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkProductionPanel :id="row.data.id" :name="row.data.barcode" :newTab="false" />
              </td>
              <td>
                <LabelPanelTypeBadge :type="row.data.type" />
              </td>
              <td>
                <LabelPanelStatusBadge :status="row.data.status" />
              </td>
              <td>
                {{row.data.panelHeight}} x {{row.data.panelWidth}}
              </td>
              <td>
                {{formatDecimal(calculateArea(row.data.panelWidth, row.data.panelHeight), 2, true)}} m²
              </td>
              <td>
                {{row.data.orderItem.stock.name}}
              </td>              
              <td>
                <LinkOrder :id="row.data.order.id" :name="row.data.order.sequenceNumber" />
              </td>
              <td>
                {{row.data.createdAt | formatDateTime}}
              </td>
              <td>
                {{row.data.dateProductionCompleted | formatDateTime}}
              </td>
              <td>
                {{row.data.dateCompleted | formatDateTime | formatHyphenEmptyValue}}
              </td>
            </tr>
          </template>
          <template v-slot:summary="summary">
            <tr key="summary">
              <td>Totals</td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{formatDecimal(summary.data.totalPanelArea, 2, true)}} m²</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </DataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import Utils from '@/utils/utils'
import LabelPanelStatusBadge from '@/modules/production/components/labelPanelStatusBadge'
import LabelPanelTypeBadge from '@/modules/production/components/labelPanelTypeBadge'

import { ProductionPanelStatusTypes, ProductionPanelStatusTypeLookup, ProductionPanelTypes, ProductionPanelTypeLookup } from '@/store/types'

export default {
  name: "ProductionPanelList",
  components: {
    LabelPanelStatusBadge,
    LabelPanelTypeBadge
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {},
        includeSummary: true
      }
      return '/production/panels?' + $.param(params)
    },
  },
  data() {
    return {
      filterOptions: [
        {
          field: 'type',
          name: 'Type',
          options: [
            { name: Utils.getLookupName(ProductionPanelTypeLookup, ProductionPanelTypes.glass), value: ProductionPanelTypes.glass, class: 'label-production-panel-type-glass' },
            { name: Utils.getLookupName(ProductionPanelTypeLookup, ProductionPanelTypes.assembly), value: ProductionPanelTypes.assembly, class: 'label-production-panel-type-assembly' },
          ]
        },
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.pending), value: ProductionPanelStatusTypes.pending, class: 'label-production-panel-status-pending' },
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.production), value: ProductionPanelStatusTypes.production, class: 'label-production-panel-status-production' },
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.recut), value: ProductionPanelStatusTypes.recut, class: 'label-production-panel-status-recut' },
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.despatch), value: ProductionPanelStatusTypes.despatch, class: 'label-production-panel-status-despatch' },
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.completed), value: ProductionPanelStatusTypes.completed, class: 'label-production-panel-status-completed' },
            { name: Utils.getLookupName(ProductionPanelStatusTypeLookup, ProductionPanelStatusTypes.cancelled), value: ProductionPanelStatusTypes.cancelled, class: 'label-production-panel-status-cancelled' }
          ]
        },
      ],
      columnList: [
        { title: "Item", data: "id" },
        { title: "Type", data: "type" },
        { title: "Status", data: "status" },
        { title: "Size", data: "size", sortable: false },
        { title: "Area", data: "area", sortable: false },
        { title: "Stock", data: "orderItem.stock.name" },
        { title: "Order", data: "order.id" },
        { title: "Creation Date", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Production Completed Date", data: "dateProductionCompleted", dateFilter: true, type: 'datetime' },
        { title: "Completed Date", data: "dateCompleted", dateFilter: true, type: 'datetime' },
      ]
    }
  },
  created() {
    this.ProductionPanelTypeLookup = ProductionPanelTypeLookup
  },
  methods: {
    calculateArea(width, height) {
      return Utils.convertMillimetreSqToMetreSq(width * height)
    }
  }
};
</script>
